export const ResetConstants = {
  RESET_STRING: '-1',
  RESET_NUMERIC: -1,
}
